
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cell-bio/[uuid]",
      function () {
        return require("private-next-pages/cell-bio/[uuid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cell-bio/[uuid]"])
      });
    }
  